import styled from "styled-components";

export const CategoriesContainer = styled.div`
  max-width: 120rem;
  padding: 4.8rem;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
`;
